import React, { useState, useRef, useEffect } from "react";
import "./AnnuaireEntrepriseContainer.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AnnuaireEntrepriseSearchBar from "../AnnuaireEntrepriseSearchBar/AnnuaireEntrepriseSearchBar";
import Header from "Components/Header/Header";
import ButtonsBarDisconnected from "Components/Header/ButtonsBarDisconnected/ButtonsBarDisconnected";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";
import { Dropdown } from "primereact/dropdown";
import EntrepriseCard from "Components/GestionAdmin/GestionMembres/EntreprisesPartenaires/EntrepriseCard/EntrepriseCard";
import { Accordion } from "primereact/accordion";
import { AccordionTab } from "primereact/accordion";
import { useFetchGetPagination } from "Services/api";
import TempPagination from "Components/Pagination/TempPagination";
import Loader from "Components/Loader/loader";

const AnnuaireEntrepriseContainer = (props) => {
  const annuaireContainerRef = useRef(null);
  const [triEntreprises, setTriEntreprises] = useState(null);
  const triEntreprisesData = [
    { label: "Par défaut", value: "Default" },
    { label: "Par secteur", value: "Secteur" },
    { label: "Par nombre croissant d'offres", value: "Croissant" },
    { label: "Par nombre décroissant d'offres", value: "Decroissant" },
  ];

  const [urlCompany, setUrlCompany] = useState("");
  const companiesQuery = useFetchGetPagination(urlCompany, props.auth.token);

  useEffect(() => {
    let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/companies`);
    url.searchParams.set("itemsPerPage", 20);
    setUrlCompany(url);
  }, []);
  return (
    <div>
      <Header
        activeIndex={props.activeIndex}
        setActiveIndex={props.setActiveIndex}
        items={props.items}
      >
        {props.auth.isConnected ? (
          <>
            <NavBarTab
              select="annuaire"
              activeIndex={props.items.activeItemAnnuaire}
              items={props.items}
            />
          </>
        ) : (
          <ButtonsBarDisconnected />
        )}
      </Header>

      <div className="article_offre">
        <div className="annuaire__container" ref={annuaireContainerRef}>
          <div>
            <h1 className="h1_trait_dessus">
              {
                props.items.itemsAnnuaire.find(
                  (item) => item.label === props.items.activeItemAnnuaire.label
                ).label
              }
            </h1>
            {/* <p>{offres.length} offres correspondent à vos critères</p> */}
            <p>{companiesQuery?.data?.length} entreprises sur notre réseau</p>
            {/* <p>Aucune entreprise ne correspond à vos criètres</p> */}
          </div>
          <div className="annuaire_filtre">
            <div className="annuaire_filtre__label">
              {/* <p>Trier par : </p> */}
              <Dropdown
                value={triEntreprises}
                options={triEntreprisesData}
                onChange={(e) => setTriEntreprises(e.value)}
                placeholder="Trier par"
              />
            </div>
          </div>
        </div>
        <AnnuaireEntrepriseSearchBar setUrlCompany={setUrlCompany} />
        <Accordion expandIcon="pi pi-sliders-h" collapseIcon="pi pi-sliders-h">
          <AccordionTab header="Fitres de recherche">
            <AnnuaireEntrepriseSearchBar setUrlCompany={setUrlCompany} />
          </AccordionTab>
        </Accordion>
        <div className="annuaire__container__cards">
          {companiesQuery.loaded ? (
            companiesQuery.data?.map((entreprise, index) => (
              <EntrepriseCard
                key={index}
                nomEntreprise={entreprise.name}
                type={
                  entreprise.structure
                    ? entreprise.structure.label
                    : entreprise.type.label
                }
                imageLogo={"entreprise2"}
                imageFond={"entrepriseFond2"}
                taille={
                  entreprise.totalStaff
                    ? entreprise.totalStaff.label
                    : "Non renseigné"
                }
                offresDisponibles={true}
                isPartner={entreprise.isPartner}
                companyId={entreprise.id}
              />
            ))
          ) : (
            <Loader></Loader>
          )}
        </div>

        <TempPagination
          result={companiesQuery}
          refItemParent={annuaireContainerRef}
          rows={20}
        />
      </div>
    </div>
  );
};

AnnuaireEntrepriseContainer.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.object,
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func,
  companies: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  companies: state.companies,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnnuaireEntrepriseContainer);
